<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Precios de Compras de Producto</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-8">
              <router-link class="btn btn-sm btn-success" :to="{ name: 'cat-productos-nuevo', params: {} }">
                <i class="fa fa-pencil"></i>
                Agregar nuevo precio de Compra
              </router-link>
              <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
            </div>
            <div class="col-sm-4 row">
              <div>
                <select v-model="filter_activo" class="form-control form-control-sm rounded bright"
                  @change="filterData">
                  <option value>Estado</option>
                  <option value="false">Inactivos</option>
                  <option value="true">Activos</option>
                </select>
              </div>
              &nbsp;&nbsp;
              <form class="form-inline justify-content-sm-end" @submit="filterDataSubmit">
                <input class="form-control form-control-sm rounded bright" placeholder="Producto" v-model="searchtext"
                  type="text" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Sku</th>
                <th>Nombre</th>
                <th class="text-center">Costos</th>
                <th class="text-center">Otros Costos</th>
                <th class="text-center">Proveedor</th>
                <th class="text-right">Fecha creación</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="rowClick(current)">
                <td>{{ current.producto }}</td>
                <td>{{ current.producto_obj.nombre }}</td>
                <td class="text-center">
                  {{ current.costo }}
                </td>
                <td class="text-center">
                  {{ current.otros_costos }}
                </td>
                <td class="text-center" v-if="current.proveedor_obj">
                  {{ current.proveedor_obj.codigo }} -
                  {{ current.proveedor_obj.nombre }}
                </td>
                <td class="text-center" v-if="!current.proveedor"></td>
                <td class="text-right">
                  {{ current.fecha_creacion | moment("DD/MM/YYYY h:mm a") }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
    <CambiarCostoProductoComponent :costodata="costodata" />
  </div>
</template>

<script>
import _ from "lodash";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import CambiarCostoProductoComponent from "@/components/compras/lista_precios_compras/CambiarCostoProductoComponent";

import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";

export default {
  components: {
    PaginationComponent,
    CambiarCostoProductoComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      costodata: {
        id: null,
      },
    };
  },
  mounted() {
    let self = this;
    this.refreshData();
    $("#modalCambiarcosto").on("hidden.bs.modal", function (e) {
      self.onPageChange(self.currentPage);
    });
  },
  methods: {
    rowClick(item) {
      let self = this;
      console.log(item);
      self.costodata = item;
      $("#modalCambiarcosto").modal("show");
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() { },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "producto-costo", params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() { },
  },
};
</script>
